import Image from 'next/image';
import React from 'react';

interface AreaIconProps {
  size?: number;
  className?: string;
}

const AreaIcon: React.FC<AreaIconProps> = ({ size = 24, className = '' }) => {
  return (
    <Image
      src="/images/icons/property-icon-area.svg"
      alt="Area icon"
      width={size}
      height={size}
      className={className}
    />
  );
};

export default AreaIcon;
